import React from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "../../base-component/base-component";

import Popover from 'src/core/gd-components/gd-popover/popover';
import DatepickerContent from './datepicker-content.jsx';
import DatetimeUtils from "core/gd/utils/datetime-utils";
import formatDateHumanize from "../../../gd/format/date-humanize";
import formatDate from "../../../gd/format/date";

export default class Datepicker extends BaseComponent {

    static propTypes = {
        disabledDays: PropTypes.arrayOf(PropTypes.shape({
            startDate: PropTypes.object,                    //Moment
            endDate: PropTypes.object,                      //Moment
            className: PropTypes.string
        })),

        value: PropTypes.object,                            // current value , Moment (!)
        timeRangeValue: PropTypes.object,                   // current time range value , Moment (!)
        humanizeValue: PropTypes.bool,
        markPastdue: PropTypes.bool,
        isSomeday: PropTypes.bool,

        onSelect: PropTypes.func,                           // on date selected -> returns moment
        onSelectSomeday: PropTypes.func,
        onSelectInbox: PropTypes.func,

        // Visualization
        skin: PropTypes.oneOf(['inline','list','form']),
        renderValue: PropTypes.oneOf(['default', 'inline', 'func']),
        formSize: PropTypes.oneOf([36, 30]),
        renderValueFunc: PropTypes.func,
        preIcon: PropTypes.string,
        showTailArrow: PropTypes.bool,

        minDate: PropTypes.object,
        maxDate: PropTypes.object,

        valueFormat: PropTypes.string,                      // format for date
        timeRangeValueFormat: PropTypes.string,             // format for time range
        placeholderText: PropTypes.string,

        onTogglePopover: PropTypes.func,

        //tether usage: http://github.hubspot.com/tether/
        popoverAttachment: PropTypes.string,
        popoverTargetAttachment: PropTypes.string,
        popoverTargetOffset: PropTypes.string,
        popoverClassName: PropTypes.string,                 //to add picker popover class for custom css
        tetherConstraints: PropTypes.array,
        attachmentType: PropTypes.oneOf(['full', 'vertical', 'horizontal']),

        addonButtons: PropTypes.arrayOf(PropTypes.shape({
            label: PropTypes.string,
            onClick: PropTypes.func,
            className: PropTypes.string
        })),

        timeStep: PropTypes.number,

        showTimeSelector: PropTypes.bool,
        showTodayButton: PropTypes.bool,
        timeRangeRequired: PropTypes.bool,
        btnToday: PropTypes.bool,
        btnTomorrow: PropTypes.bool,
        btnSomeday: PropTypes.bool,
        btnInbox: PropTypes.bool,
        btnNoValue: PropTypes.bool,
        btnNoValueLabel: PropTypes.string,
        btnDelete: PropTypes.bool,

        disabled: PropTypes.bool,
    };

    //tether usage (tetherConstraints): http://github.hubspot.com/tether/
    static defaultProps = {
        humanizeValue: false,
        markPastdue: true,
        placeholderText: 'Date',
        skin: 'inline',
        renderValue: 'default',
        formSize: 36,
        popoverAttachment: 'top center',
        popoverTargetAttachment: 'bottom center',
        attachmentType: "horizontal",
        tetherConstraints: [{
            to: 'window',
            attachment: 'together',
            pin: true
        }],
        addonButtons: [],
        timeStep: 15,
    };

    state = {
        showPopover: false,
        value: this.props.value,
        timeRangeValue: this.props.timeRangeValue
    };

    classMain = "gd-datepicker-new";

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            value: nextProps.value,
            timeRangeValue: nextProps.timeRangeValue
        });
    }

    shouldComponentUpdate(nextProps, nextState) {
        return !(_.isEqual(nextProps,this.props) && _.isEqual(nextState,this.state));
    }

    onClick = (e) => {
        if (e) e.stopPropagation();
        this.showPopover();
    };

    showPopover = () => {this.setState({showPopover: true}, ()=>{if (this.props.onTogglePopover) this.props.onTogglePopover(true);});};
    hidePopover = () => {this.setState({showPopover: false}, ()=>{if (this.props.onTogglePopover) this.props.onTogglePopover(false);});};

    onClickOutside = (e) => {
        if (gd.utils.Dom.findNodeByClassName(e.target, ['time-selector-popover-content'])) return;
        this.hidePopover();
    }

    onSelect = (date) => {
        let startMoment, endMoment
        if (this.state.timeRangeValue) {
            startMoment = this.state.timeRangeValue.start;
            endMoment = this.state.timeRangeValue.end;
        } else if (this.props.timeRangeRequired) {
            startMoment = DatetimeUtils.stickToSteps(Moment(),this.props.timeStep);
            endMoment = DatetimeUtils.stickToSteps(Moment().add(1,'hour'),this.props.timeStep);
        }

        const timeRangeValue = startMoment ? Moment.range(DatetimeUtils.setTime(date,startMoment), DatetimeUtils.setTime(date,endMoment)) : null;

        this.setState( {
            value: date,
            timeRangeValue: timeRangeValue,
            showPopover: false
            }, ()=>{
            if (this.props.onTogglePopover) this.props.onTogglePopover(false);
            this.props.onSelect(this.state.value, this.state.timeRangeValue);
        });
    };

    onSelectSomeday = () => {
        if (this.props.onSelectSomeday) this.props.onSelectSomeday();
        this.hidePopover();
    }

    onSelectInbox = () => {
        if (this.props.onSelectInbox) this.props.onSelectInbox()
        this.hidePopover()
    }

    onSelectTimeRange = (timeRange) => {
        if (!this.state.value) {
            const today = Moment();

            this.setState( {
                value: today,
                timeRangeValue: Moment.range(DatetimeUtils.setTime(today,timeRange.start), DatetimeUtils.setTime(today,timeRange.end)),
            }, ()=>{
                this.props.onSelect(this.state.value, this.state.timeRangeValue);
            });
        } else {
            this.setState( {
                timeRangeValue: Moment.range(DatetimeUtils.setTime(this.state.value,timeRange.start), DatetimeUtils.setTime(this.state.value,timeRange.end)),
            }, ()=>{
                this.props.onSelect(this.state.value, this.state.timeRangeValue);
            });
        }
    }

    onResetClick = (e) => {
        e.stopPropagation();
        this.onSelect(null);
    };

    renderPopover = () => {
        if (this.state.showPopover) {
            const classes = Classes(this.classMain+'-popover', this.props.popoverClassName);

            return (
                <Popover popoverClass={classes}
                         className={this.classMain+"-container"}
                         targetClass={this.classMain+"-target"}
                         attachment={this.props.popoverAttachment}
                         targetAttachment={this.props.popoverTargetAttachment}
                         targetOffset={this.props.popoverTargetOffset}
                         attachmentType={this.props.attachmentType}
                         constraints={this.props.tetherConstraints}
                         onClickOutside={this.onClickOutside}>
                    <DatepickerContent disabledDays={this.props.disabledDays}
                                       value={this.props.value}
                                       timeRangeValue={this.props.timeRangeValue}
                                       onSelect={this.onSelect}
                                       onSelectSomeday={this.onSelectSomeday}
                                       onSelectInbox={this.onSelectInbox}
                                       onSelectTimeRange={this.onSelectTimeRange}
                                       minDate={this.props.minDate}
                                       maxDate={this.props.maxDate}
                                       addonButtons={this.props.addonButtons}
                                       showTimeSelector={this.props.showTimeSelector}
                                       showTodayButton={this.props.showTodayButton}
                                       timeRangeRequired={this.props.timeRangeRequired}
                                       timeStep={this.props.timeStep}
                                       btnToday={this.props.btnToday}
                                       btnTomorrow={this.props.btnTomorrow}
                                       btnSomeday={this.props.btnSomeday}
                                       btnInbox={this.props.btnInbox}
                                       btnNoValue={this.props.btnNoValue}
                                       btnNoValueLabel={this.props.btnNoValueLabel}
                                       disabled={this.props.disabled}/>
                </Popover>
            );
        }
    };

    renderValue = () => {
        const valueClasses = Classes(this.classMain+'-value', this.classMain+'-target', {
            'past': this.props.markPastdue && this.state.value && this.state.value.isBefore(Moment(),'days'),
            'not-set': !this.props.isSomeday && !this.state.value
        });

        // DO not use default props because user might change settings on the fly
        const timeRangeValueFormat = this.props.timeRangeValueFormat ? this.props.timeRangeValueFormat : gd.session.me.formatSettings.time;

        let valueLabel;
        // if (this.state.value)   valueLabel = this.props.humanizeValue ? gd.utils.momentHumanize(this.state.value,valueFormat) : this.state.value.format(valueFormat);
        if (this.state.value) {
            valueLabel = this.props.humanizeValue
                // ? gd.utils.momentHumanize(this.state.value,valueFormat)
                ? formatDateHumanize(this.state.value,this.props.valueFormat)
                : formatDate(this.state.value, this.props.valueFormat);
        } else {
            valueLabel = this.props.placeholderText;
        }

        const timeRangeValueLabel = this.state.timeRangeValue ?
            ', {0} - {1}'.f(this.state.timeRangeValue.start.format(timeRangeValueFormat), this.state.timeRangeValue.end.format(timeRangeValueFormat)) : null;

        const preIcon = this.props.preIcon ? <div className={Classes("ui5-ico-13", "m-r-5", "icon", this.props.preIcon)}/> : null;
        const tailArrow = this.props.showTailArrow ? <div className="arrow ui5-arrow-toggle s8 open m-l-5"/> : null;

        switch (this.props.renderValue) {
            case 'inline':
                if (!this.props.isSomeday && !this.state.value) valueLabel = <div className="i5-deadline" />;
                return <div className={valueClasses}>{valueLabel}{timeRangeValueLabel}</div>;

            case 'func':    return <div className={valueClasses}>{this.props.renderValueFunc(this.state.value, this.state.timeRangeValue)}</div>;

            case 'default':
            default:        return <div className={valueClasses}>{preIcon}{valueLabel}{timeRangeValueLabel}{tailArrow}</div>;
        }
    };

    render() {
        const classes = Classes(this.props.className, this.classMain, this.props.skin+"-skin", 'render-'+this.props.renderValue, {
            disabled: this.props.disabled,
            'form-size-30': (this.props.skin === 'form' && this.props.formSize===30)
        });

        return (
            <div className={classes} onClick={this.props.disabled ? null : this.onClick}>
                {this.renderValue()}
                {this.renderPopover()}
                {this.props.children}
                {this.state.value && this.props.btnDelete &&
                <div className="delete-button ui5-ico-delete s14 black m-l-5" onClick={this.onResetClick}/>}
            </div>
        );
    }
}
